import taxBillPayments from './tax-bill-payments';
import taxBills from './tax-bills';
import taxReturns from './tax-returns';
import taxSubmissions from './tax-submissions';

let messages = Object.assign({}, taxBillPayments, taxBills, taxReturns, taxSubmissions);

export default messages;
